import { apiUrls } from "../../utils/app-constants";
import { apiSlice } from "../services/apiSlice";

export const settingsApi = apiSlice
  .enhanceEndpoints({
    tagTypes: ["user"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getStaticPage: builder.query({
        query: ({ type }) => {
          // const searchParams = new URLSearchParams(params).toString();
          return {
            url: `/admin/setting/${type}`,
            method: "GET",
          };
        },
        // providesTags: ["user"],
      }),
      savePage: builder.mutation({
        query: ({ data, type }) => {
          console.log(data);
          console.log(type);
          return {
            url: `/admin/setting/${type}`,
            method: "PATCH",
            body: data,
          };
        },
        // invalidatesTags: ["user"],
      }),
    }),
  });

export const { useGetStaticPageQuery, useSavePageMutation } = settingsApi;